import React from 'react'

export const PreviewImages = () =>{

    const [list] = React.useState([{id:43},{id:44},{id:45},{id:46},{id:43},{id:44}])

    return list.length>0 || list.length >= 4 ? (
        <div className="preview-images-component" >
            <div className="flex">
                <h4 className="title">Gallery</h4>
                <div className="action">See all</div>
            </div>
            <div className={`preview-images images-len-${list?.length+1}`}>
                {
                    list?.map((item,i)=>{
                        if(i>=6) return true;
                        return (
                            <img src={`/assets/images/projects/${item.id}.jpg`} key={'preview_image'+i} alt="" />
                        )
                    })
                }   
            </div>
        </div>
    ):<></>
} 
 
